// src/components/common/CustomCheckbox.js
import { CheckIcon } from '@heroicons/react/24/solid';

const CustomCheckbox = ({ checked, onChange, disabled = false, label, className = '', color = 'primary' }) => {
  const checkedClasses =
    color === 'red'
      ? 'bg-[var(--color-glassy-red)] shadow-md shadow-red-500/40'
      : 'bg-primary shadow-md shadow-orange-500/40';
  const labelHoverClass = color === 'red' ? 'hover:text-red-500' : 'hover:text-primary';

  return (
    <label className={`flex items-center space-x-2 cursor-pointer ${disabled ? 'opacity-50 cursor-not-allowed' : ''} ${className}`}>
      <div className="relative">
        <input type="checkbox" checked={checked} onChange={onChange} disabled={disabled} className="sr-only" />
        <div
          className={`
            w-5 h-5 rounded-md border border-border transition-all duration-200 flex items-center justify-center relative overflow-hidden
            ${checked ? checkedClasses : ''}
            ${disabled ? 'cursor-not-allowed opacity-60' : 'cursor-pointer hover:shadow-lg'}
          `}
        >
          {/* Glass overlay for checked state */}
          {checked && (
            <div className="absolute inset-0 bg-gradient-to-br from-white/30 to-transparent opacity-70 dark:from-white/10 dark:opacity-50" />
          )}

          {checked && <CheckIcon className="w-3 h-3 text-white relative z-10 drop-shadow-sm" />}
        </div>
      </div>
      {label && (
        <span className={`font-medium transition-colors duration-200 text-content-primary ${disabled ? '' : labelHoverClass}`}>{label}</span>
      )}
    </label>
  );
};

export default CustomCheckbox;
